import axios from 'axios';
import keycloak from '../keycloak';

// Configurer l'URL de base pour les requêtes API
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api'
});

// Intercepteur de requêtes : rafraîchit le token si besoin et l'attache en Bearer.
// (Le backend valide ce token côté Express — cf. middleware auth Keycloak.)
api.interceptors.request.use(
  async config => {
    if (keycloak && keycloak.authenticated) {
      try {
        await keycloak.updateToken(30); // refresh si le token expire dans < 30s
      } catch (e) {
        console.warn('Échec du refresh du token, redirection login', e);
        keycloak.login();
        return Promise.reject(e);
      }
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Intercepteur de réponses : gestion globale des erreurs (+ 401 → re-login)
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && keycloak) {
      keycloak.login();
    }
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default api;
